/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Layout from "../../../Layouts/Layout";
import { Helmet } from "react-helmet-async";
import Container from "../../../../components/Container/Container";
import Button from "@mui/material/Button";
import error404PageStyle from "./error404PageStyle";
import { Link } from "react-router-dom";
import backgroundTeaser from "../../../../assets/img/generic/404_Not_Found.svg";
import { gaSet } from "../../../../services/cookieService";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";

class Error404Page extends React.Component {
  render() {
    const title = "404 | Legalbird";
    gaSet({ title: title });

    return (
      <Layout minimal backgroundType={"homepage"}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Container sx={error404PageStyle.container}>
          <Grid container direction={"row-reverse"} spacing={3}>
            <Grid item xs={12} md={6}>
              <Box component={"img"} src={backgroundTeaser} alt={"404 Page not Found"} sx={error404PageStyle.teaserImage} />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant={"h3"}>Diese Seite konnte nicht gefunden werden</Typography>
              <p>
                Gründe dafür könnten sein, dass Sie eine falsche oder veraltete URL aufgerufen haben - bitte überprüfen Sie diese noch einmal. Oder aber wir
                haben die betreffende Seite archiviert, verschoben oder umbenannt.
              </p>
              <p>Vielleicht können Sie den von Ihnen gewünschten Inhalt über unsere Startseite finden.</p>
              <Button component={Link} to={"/"} variant={"contained"} color={"primary"} sx={error404PageStyle.button}>
                zur Startseite
              </Button>
            </Grid>
          </Grid>
        </Container>
        <br />
      </Layout>
    );
  }
}

export default Error404Page;
